import {
  useRepositoryLanguages,
  useSearchDocumentParams
} from "./useDocumentList"

export function useDocumentListLocales() {
  const { searchDocumentParams, updateSearchDocumentParams } =
    useSearchDocumentParams()

  const { masterLocaleId, langs } = useRepositoryLanguages()

  const locale = searchDocumentParams.language?.toString() || masterLocaleId

  function updateLocale(value: string) {
    updateSearchDocumentParams({ language: [value] })
  }

  return { locale, langs, updateLocale }
}
